import { render, staticRenderFns } from "./ViewTitle.vue?vue&type=template&id=50ee4c5f&"
import script from "./ViewTitle.vue?vue&type=script&lang=js&"
export * from "./ViewTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports